import { useQuery } from 'react-query';
import { network } from 'services/network';
import { ProjectTreeNode } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';

const getVersionList = (params: QueryParams) => {
    return network.post('api/bo/getVersionDetails', params).then((response) => response.data);
};

export const useQueryVersionList = (params: QueryParams) => {
    return useQuery<string[], QueryError, QueryResponse[]>({
        queryKey: ['versionList', params],
        queryFn: () => getVersionList(params),
        enabled: params.hashList.length > 0,
        cacheTime: 0,
    });
};

interface QueryParams {
    hashList: string[];
}
export interface QueryResponse {
    contractId: number;
    contractName: string;
    contractUuid: ProjectTreeNode['uuid'];
    maxLevel: number;
    projectId: number;
    projectName: string;
    projectUuid: ProjectTreeNode['uuid'];
    sourceFile: string;
    versionDate: number;
    versionDbId: number;
    versionHashCode: number;
    versionName: string;
    versionUniqueId: number;
}
